import { useEffect, useState } from "react";
import { Box, Card, CircularProgress, Grid, IconButton, Tooltip, Typography, } from "@mui/material";
import { useSelector } from "react-redux";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useNavigate, useParams } from "react-router-dom";
import CustomTable from "../../components/customTable/customTable";
import { useTQuery } from "../../utils/useTQuery";
import { useDispatch } from 'react-redux';
import { setSelectedRow } from '../../slice/selectedRowSlice';

const ApplicantsInTimeSheet = () => {
    const { ID } = useParams();
    const { userDetails } = useSelector(state => state.user);
    const USER_TYPE = userDetails.USER_TYPE;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [event, setEvent] = useState({})
    // const { jobData } = useSelector(state => state.job);
    const [jobData, setJobData] = useState({});


    const { data, isLoading } = useTQuery(
        ["AssociateClinician", ID],
        ID ? `/job/applicantsAndJobDetails?${new URLSearchParams({ ID }).toString()}` : null,
        'get',
        !!ID,
    );

    useEffect(() => {
        if (data?.STATUS) {
            data?.OUTPUT && setJobData(data?.OUTPUT);
        }
    }, [data?.OUTPUT, data?.STATUS]);

    const col = [
        {
            name: 'Clinician',
            selector: row => row?.clinician?.FULL_NAME,
            reorder: true,
            sortable: true,

        },

        {
            name: 'Email Address',
            selector: row => row?.clinician?.EMAIL_ADDRESS,
            reorder: true,
            sortable: true,

        },
        {
            name: 'Phone No.',
            selector: row => row?.clinician?.PHONE_NUMBER,
            reorder: true,
            sortable: true,

        },
        {
            name: 'Job Type',
            selector: row => row?.job?.JOB_TYPE || 'N/A',
            reorder: true,
            sortable: true,

        },

        {
            name: 'Service Date',
            selector: row => new Date(row?.job?.SERVICE_DATE).toDateString(),
            reorder: true,
            sortable: true,

        },
        {
            name: 'Approved Timesheet',
            selector: row => row?.timesheet?.length || 'N/A',
            reorder: true,
            sortable: true,
        },
        {
            name: 'Action',
            button: true,
            cell: row => (
                <div style={{ paddingLeft: "15px" }}>
                    <Tooltip title="View Details">
                        <IconButton
                            size="small"
                            onClick={() => handleRowClick(row)}
                        >
                            <MoreHorizIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            ),
            reorder: true,
            center: true,
        },
    ];
    const handleRowClick = (row) => {
        dispatch(setSelectedRow(row));
        navigate(`/${USER_TYPE}/timesheet/clinician-details/${row.ID}`);
    };
    if (isLoading) {
        return (
            <div  style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}>
                <CircularProgress size={30} />
            </div>
        );
    }

    return (
        <>
            <Grid container >

                <Box onClick={() => navigate(-1)} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <IconButton >
                        <ChevronLeftIcon />
                    </IconButton>
                    <Typography variant="body1"  >
                        Back
                    </Typography>
                </Box>

                <Grid item lg={12}>
                    <Card>
                        <Grid container >
                            <Grid item lg={12} p={2}>
                                <Box display="flex" justifyContent="space-between">
                                    <Box display="flex" visibility="hidden"></Box>
                                    <Box display="flex" >
                                        <Grid mt={1}>
                                            <Typography style={{ backgroundColor: jobData?.JOB_STATUS === "Clinician Hired" ? 'linear-gradient(to right,#4eb3e8,#6ebe44)' : "#f6b613", borderRadius: "20px", padding: "1px 20px", color: "#ffffff", fontWeight: 500, fontSize: "14px" }}>{jobData.adminActionType || "Pending Request"}</Typography>
                                        </Grid>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={6} p={2}>
                                <Box>

                                    <Typography variant="h2" pt={2} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>
                                    <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>

                                    <Typography variant="h4" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>Glendora, CA</Typography>
                                </Box>
                            </Grid>
                            <Grid item lg={12} >
                                <Box px={1.5} display="flex" justifyContent="space-between">
                                    <Box display="flex" gap={3} justifyContent="flex-start">
                                        {jobData?.jobs_role?.ROLE_NAME && (
                                            <Typography
                                                sx={{
                                                    backgroundColor: '#eef7e9',
                                                    borderRadius: '20px',
                                                    padding: '10px 20px',
                                                    color: 'black',
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {jobData.jobs_role.ROLE_NAME}
                                            </Typography>
                                        )}
                                        {jobData?.JOB_TYPE && (
                                            <Typography
                                                sx={{
                                                    backgroundColor: '#eef7e9',
                                                    borderRadius: '20px',
                                                    padding: '10px 20px',
                                                    color: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {jobData?.JOB_TYPE}
                                            </Typography>
                                        )}
                                        {jobData?.SERVICE_TYPE && (
                                            <Typography
                                                sx={{
                                                    backgroundColor: '#eef7e9',
                                                    borderRadius: '20px',
                                                    padding: '10px 20px',
                                                    color: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {jobData?.SERVICE_TYPE}
                                            </Typography>
                                        )}
                                    </Box>



                                </Box>
                            </Grid>

                        </Grid>
                    </Card>
                </Grid >
            </Grid >

            <Grid mt={2}>
                <CustomTable
                    column={col}
                    event={(e) => { setEvent(e) }}
                    url={"/job/fetchAssociateCliniciansbyJobId"}
                    headline={"Applicants"}
                    payload={{ jobID: ID, }}
                />

            </Grid>
        </>


    )
};

export default ApplicantsInTimeSheet;

